import { gkApi } from './index';

const inventoryApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    getInventorySheet: builder.query({
      query: (eventId) => ({
        url: '/inventory-count/sheet/',
        method: 'get',
        params: { event: eventId },
      }),
      providesTags: ['INVENTORY_COUNT'],
    }),
    listInventoryCounts: builder.query({
      // Scoped to the selected event server-side (the param is required), so the
      // list only carries the current event's counts as the history grows.
      query: (eventId) => ({
        url: '/inventory-count/',
        method: 'get',
        params: { event: eventId, limit: 200 },
      }),
      providesTags: ['INVENTORY_COUNT'],
    }),
    getInventoryCount: builder.query({
      query: (id) => ({
        url: `/inventory-count/${id}/`,
        method: 'get',
      }),
      providesTags: ['INVENTORY_COUNT'],
    }),
    submitInventoryCount: builder.mutation({
      query: (payload) => ({
        url: '/inventory-count/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: ['INVENTORY_COUNT'],
    }),
  }),
});

export const {
  useGetInventorySheetQuery,
  useListInventoryCountsQuery,
  useGetInventoryCountQuery,
  useSubmitInventoryCountMutation,
} = inventoryApi;
